import { Modal as MuiModal, Box } from '@mui/material';
import { ModalProps } from './Modal.props';

export const Modal = ({ children, onClose, ...props }: ModalProps) => {
  return (
    <MuiModal onClose={onClose} {...props}>
      <Box className="modal-container">
        <Box className="modal-content">{children}</Box>
      </Box>
    </MuiModal>
  );
};

export default Modal;
